import { Suspense } from "react";
import Checkbox from "../../Checkbox";
import {useFindOrganizationsMapStore, useMapStore, DEFAULT_ZOOM} from "../store.jsx";
import classNames from "classnames";
import s from "./MapCheckbox.module.css";
import { branchCodes } from "../../../ts/branches";

export default function MapCheckbox() {
    const fairIsChecked = useFindOrganizationsMapStore(
        (state) => state.fairIsChecked,
    );
    const setFairIsChecked = useFindOrganizationsMapStore(
        (state) => state.setFairIsChecked,
    );

    const resetSearch = useFindOrganizationsMapStore(
        (state) => state.resetSearch,
    );
    const checkboxContainerClasses = classNames(s.root, {});

    const getOrganizations = useFindOrganizationsMapStore(
        (state) => state.getOrganizations,
    );
    const bransch = useFindOrganizationsMapStore((state) => state.bransch);
    const inputValue = useFindOrganizationsMapStore(
        (state) => state.inputValue,
    );
    const map = useMapStore((state) => state.map);

    const handleChecked = (e) => {
        const newValue = !fairIsChecked;
        setFairIsChecked(newValue);

        if (!inputValue && !bransch && !newValue) {
            map?.setZoom(DEFAULT_ZOOM);
            return resetSearch();
        }

        getOrganizations(bransch, inputValue, newValue); //invert so that the value is correct, since the state is not updated yet
    };

    return (
        (bransch === branchCodes?.TFVAG || bransch === "") && (
            <Suspense fallback={<div>Loading...</div>}>
                <div className={checkboxContainerClasses}>
                    <Checkbox
                        label="Visa endast Fair Transport-certifierade företag"
                        checked={fairIsChecked}
                        onChange={handleChecked}
                    />
                </div>
            </Suspense>
        )
    );
}
